import { useScreenWidth } from "@/frontend/shared/lib/hooks/useScreenWidth";
import { SquareButton, TSquareButtonProps } from "../SquareButton/SquareButton";
import { NormalButton } from "../NormalButton/NormalButton";

type TSquareNormalButtonProps = TSquareButtonProps & {
  customBreakpoint?: number;
};

export function SquareNormalButton({ customBreakpoint = 768, ...props }: TSquareNormalButtonProps) {
  const isMobile = useScreenWidth() <= customBreakpoint;

  if (isMobile) {
    return <SquareButton {...props} />;
  }

  return <NormalButton {...props} color={undefined} />;
}
